import React from "react";
import { Badge, colors } from "../design/badge";
import { SideType } from "../models/SideType";
import { CustodyOrderType, custodyOrderTypes } from "../models/CustodyOrder";

interface Props {
  type?: CustodyOrderType;
}

const CustodyOrderTypeBadge: React.FC<Props> = ({ type }) => {
  if (!type) return null;
  const custodyOrderType = custodyOrderTypes[type];
  return (
    <Badge color={custodyOrderType.color as keyof typeof colors}>
      {custodyOrderType.label}
    </Badge>
  );
};

export default CustodyOrderTypeBadge;
